import { Component, Input } from '@angular/core';

@Component({
  selector: 'vfs-template-secondary-small',
  templateUrl: './template-secondary-small.component.html',
  styleUrls: ['./template-secondary-small.component.scss']
})
export class TemplateSecondarySmallComponent {
  @Input() noPadding = false;
  @Input() border = false;
}
